// extracted by mini-css-extract-plugin
export default {"Preference":"Preference_Preference__69TKG","Preference__title":"Preference_Preference__title__O-Ygk","Title__backButton":"Preference_Title__backButton__n5T5Q"};